import { render } from "./ClickCounter.vue?vue&type=template&id=3d604d15&scoped=true"
import script from "./ClickCounter.vue?vue&type=script&lang=js"
export * from "./ClickCounter.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-3d604d15"

export default script